module.exports = __webpack_public_path__ + "static/media/User Stories.c529f6f5.png";